export type CheckboxEvaluationMode = 'strict' | 'answerRisk';

interface CheckboxAnswer {
  checked?: boolean,
  correct?: boolean,
  risk?: string,
}

export function isCheckboxEvaluationMode(value: unknown): value is CheckboxEvaluationMode {
  return value === 'strict' || value === 'answerRisk';
}

export function resolveCheckboxEvaluationMode(value: unknown): CheckboxEvaluationMode {
  if (value === undefined) {
    return 'strict';
  }
  if (!isCheckboxEvaluationMode(value)) {
    throw new Error(`Invalid checkbox evaluation mode: ${String(value)}`);
  }
  return value;
}

export function evaluateCheckbox(answers: CheckboxAnswer[], evaluationMode: unknown) {
  const mode = resolveCheckboxEvaluationMode(evaluationMode);
  const isMismatch = (answer: CheckboxAnswer) => (
    (answer.checked === true && answer.correct === false)
    || (answer.checked === false && answer.correct === true)
  );

  if (mode === 'strict') {
    return answers.some(isMismatch) ? 'rot' : 'grün';
  }

  const risks = answers
    .filter((answer) => isMismatch(answer) || answer.risk === 'neutral')
    .map((answer) => answer.risk);

  if (risks.includes('rot')) {
    return 'rot';
  }
  if (risks.includes('orange')) {
    return 'orange';
  }
  if (risks.includes('neutral')) {
    return 'neutral';
  }
  return 'grün';
}
